import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '../../../../../common/Button/Button';
import style from './ApplyCardForm.module.scss';
import CardFormKyc from './CardFormKyc/CardFormKyc';
import CardTypeApply from './CardTypeApply/CardTypeApply';
import ApplicationSuccessModal from '../../../../../common/Modals/ApplicationSuccessModal/ApplicationSuccessModal';
import KycApprovedModal from '../../../../../common/Modals/KycApprovedModal/KycApprovedModal';
import { applyCardApplicationAction } from '../../../../../../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { STATUS_CODE } from '../../../../../../utils/constants';
import { ROUTES } from '../../../../../../routes';

const ApplyCardForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showKycApprovedModal, setShowKycApprovedModal] = useState(false);
    const [kycRedirectUrl, setKycRedirectUrl] = useState("");
    const [fallbackRedirectUrl, setFallbackRedirectUrl] = useState("");

    const [step, setStep] = useState(
        () => new URLSearchParams(window.location.search).get("step") || "kycForm"
    );
    const stepRef = useRef(step);
    stepRef.current = step;

    const routingStep = () =>
        new URLSearchParams(window.location.search).get("step") || stepRef.current;
    const handleKycSubmit = (redirectUrl) => {
        setKycRedirectUrl(redirectUrl);
        setStep("pending");
    };

    const handlePendingSubmit = () => {

        const url = kycRedirectUrl || fallbackRedirectUrl;
        if (url) {
            window.location.href = url;
        }
    };
    const cardDetailsData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await dispatch(applyCardApplicationAction());
            const status = res?.data?.data?.applicationStatus;
            const stepForRoute = routingStep();

            if (res?.status === STATUS_CODE.successful) {
                if (status === "needsVerification") {
                    if (stepForRoute !== "pending") navigate(`${ROUTES.APPLY_CARD_FORM}?step=pending`);
                    const link = res?.data?.data?.applicationCompletionLink;
                    const redirectUrl =
                        `${link.url}?userId=${link.params.userId}` +
                        `&signature=${encodeURIComponent(link.params.signature)}` +
                        `&redirect=${encodeURIComponent(
                            `${window.location.origin}/auth/apply-card?kycStatus=pending`
                        )}`;
                    if (redirectUrl) {
                        setLoading(false);
                        setFallbackRedirectUrl(redirectUrl);
                    }
                } else if (status === "approved" || status === "approve") {
                    // KycApprovedModal only opens from initiateApplicationAction (CardFormKyc submit), not from this fetch
                    if (stepForRoute !== "cardType") {
                        navigate(`${ROUTES.APPLY_CARD_FORM}?step=cardType`);
                    }
                    setLoading(false);
                } else if (status === "denied") {
                    navigate(ROUTES.APPLY_CARD);
                } else if (status === "" || !status || res?.data?.message === "User not found.") {
                    if (stepForRoute !== "kycForm") navigate(`${ROUTES.APPLY_CARD_FORM}?step=kycForm`);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log("Error");
        }
    }, [dispatch, navigate]);

    useEffect(() => {
        if (kycRedirectUrl === "") {
            cardDetailsData()
        } else {
            setLoading(false);
        }
    }, [step, kycRedirectUrl, cardDetailsData])

    useEffect(() => {
        const stepFromUrl = searchParams.get("step");
        if (stepFromUrl) {
            setStep(stepFromUrl);
        }
    }, [searchParams]);

    return (
        <>
            <section className={style.applyCardForm}>
                {step === "kycForm" && (
                    <CardFormKyc
                        onSubmit={handleKycSubmit}
                        onApplicationApproved={() => setShowKycApprovedModal(true)}
                    />
                )}
                {step === "pending" && (
                    <div className={style.applyCardForm_kycpending}>
                        <h3>KYC Pending</h3>
                        <Button
                            className={style.btnSize}
                            onClick={handlePendingSubmit}
                            variant='small_size'
                            fluid
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Submit"}
                        </Button>
                    </div>
                )}
                {step === "cardType" && (
                    <CardTypeApply
                        onClick={() => setShowSuccess(true)}
                    />
                )}
            </section>
            <ApplicationSuccessModal
                show={showSuccess}
                handleClose={() => setShowSuccess(false)}

            />
            <KycApprovedModal
                show={showKycApprovedModal}
                onDismiss={() => {
                    setShowKycApprovedModal(false);
                    navigate(ROUTES.APPLY_CARD);
                }}
                onApplyNow={() => {
                    setShowKycApprovedModal(false);
                    navigate(`${ROUTES.APPLY_CARD_FORM}?step=cardType`);
                }}
            />
        </>
    )
}

export default ApplyCardForm